// Highcharts indicator line series extend line series, so they are straight.
// this helps make indicator lines spline.
export const splineIndicatorLines = (Highcharts) => {
    const indicatorSeriesTypes = ["sma", "ema", "wma"]; // abands extend sma
    for (const st of indicatorSeriesTypes) {
        Highcharts.seriesTypes[st].prototype.getPointSpline = Highcharts.seriesTypes.spline.prototype.getPointSpline;
    }
};
